import * as React from "react";
import "./MainMenu.scss";
import {IFeature} from "../OverviewScreen";
import {MainMenuButton} from "./mainMenuButton/MainMenuButton";

export interface MainMenuProps {
    currentSelectedLink: string;
    features: IFeature[];

    mouseEventHandler: (e: any, feature: IFeature) => void;
}

export class MainMenu extends React.Component<MainMenuProps, {}> {

    constructor(props: any, context?: any) {
        super(props, context);
    }

    createMenuEntries = (feature: IFeature, index: number, entries) => {
        const isOddCount = entries.length % 2;
        const isLast = (isOddCount) ? (index === entries.length - 1) : (index >= entries.length - 2);
        const active: boolean = (this.props.currentSelectedLink && this.props.currentSelectedLink.indexOf(feature.$.href) == 0);
        return <MainMenuButton active={active}
                               feature={feature}
                               index={index}
                               key={'mm-btn-' + index}
                               isLastColumn={isLast}
                               mouseEventHandler={this.props.mouseEventHandler}/>
    };

    render() {
        const entries: JSX.Element[] = this.props.features.map(this.createMenuEntries);

        return <div className='MainMenu main-menu' key={"mainMenu"}>
            <ul className={'menu'}>
                {entries}
            </ul>
        </div>
    }
}
